export default{

    currentScore : 40000,
    currentEnigma : 1,
    timeDiscount: 0,
    extract : []
}